import React, { useEffect, useState } from "react";
import { API_URL } from "../config";
import AiHtmlIframe from "./AiHtmlIframe";
import logger from "../services/logger";

/**
 * AiContentSlot — affiche un bloc HTML g\u00e9n\u00e9r\u00e9 par l'IA depuis l'admin.
 *
 * Composant partag\u00e9 entre tous les th\u00e8mes du site.
 *
 * Charge le bloc via l'API publique puis d\u00e9l\u00e8gue le rendu \u00e0 AiHtmlIframe
 * (gestion iframe sandbox + auto-resize + traduction + liens).
 *
 * Le linkBehavior est "blank" car les blocs sont des encarts dans des pages —
 * cliquer sur un lien ne doit pas remplacer la page enti\u00e8re.
 */
export default function AiContentSlot({ blockId, lang }) {
    const [block, setBlock] = useState(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!blockId) return;
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/ai-content-blocks/id/${blockId}`);
                const json = await res.json();
                if (cancelled) return;
                setBlock(json?.data || null);
            } catch (e) {
                logger.error({ err: e }, "AiContentSlot fetch error:");
            } finally {
                if (!cancelled) setLoaded(true);
            }
        })();
        return () => { cancelled = true; };
    }, [blockId]);

    if (!blockId) return null;
    if (loaded && !block?.html) return null;
    if (!block?.html) return null;

    return (
        <AiHtmlIframe
            className="ai-content-slot"
            html={block.html}
            i18n={block.i18n}
            mainLang={block.mainLang || "fr"}
            lang={lang}
            linkBehavior="blank"
        />
    );
}
